import { render, staticRenderFns } from "./addProgram.vue?vue&type=template&id=23f795b6&"
import script from "./addProgram.vue?vue&type=script&lang=js&"
export * from "./addProgram.vue?vue&type=script&lang=js&"
import style0 from "./addProgram.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports